import { getContext } from 'configs/context';

import { WEBHOOK_CALCULATOR_URL } from 'configs/constants';

interface CreditCalculatorResponse {
  response?: {
    result?: {
      usageAmount?: number;
    };
  };
  status?: string;
}

export async function getWebhookUsageAmount(webhookId: string): Promise<number> {
  const response = await getContext().utils.api.fetch(WEBHOOK_CALCULATOR_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ params: { webhookId } }),
  });

  const data: CreditCalculatorResponse = await response.json();

  if (data?.status === 'error') {
    throw new Error('Failed to calculate webhook credits');
  }

  return data.response?.result?.usageAmount ?? 0;
}
